import React from 'react'
import { useFlags, useGetDigitalCardByToken } from 'src/react_query'
import ViewAct from '../components/ViewAct/ViewAct'
import { ActRoute } from '../routes/ActRoute'
import { useFlag, useQueryParams } from 'src/hooks'
import { LoadingSpinner } from '@sendoutcards/quantum-design-ui'
import ActSetup from '../components/ActSetup/ActSetup'

type ActProps = {
  route: ActRoute
}

const Act: React.FC<ActProps> = ({ route }) => {
  const { token } = useQueryParams()
  const { data: flags } = useFlags()
  const { data, isLoading } = useGetDigitalCardByToken({ token: token ?? '' })

  const { disableActDemo: isDisabledDemo } = useFlag(flags ?? [])

  const loadScreenSyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100dvh',
  }

  if (isLoading) {
    return (
      <div style={{ ...loadScreenSyles }}>
        <LoadingSpinner size="large" />
      </div>
    )
  }

  if (!route.subroute) {
    return data ? (
      <ViewAct digitalCard={data} isDemo={!isDisabledDemo} />
    ) : (
      <div style={{ ...loadScreenSyles }}>
        <LoadingSpinner size="large" />
      </div>
    )
  }

  return <ActSetup route={route} cardId={route.subroute.cardId} />
}

export default Act
